import React from "react";
import { ErrorLabelStyled } from "./ErrorLabel.css";

interface Props {
  message: string;
}
export const ErrorLabel = ({ message }: Props) => {
  return <ErrorLabelStyled variant="label">{message}</ErrorLabelStyled>;
};
